/* eslint-disable no-unused-vars */
import React from "react";
import { useState } from "react";
import { Container } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { TextDecrypt } from "../content/TextDecrypt";
import Carousel from 'react-material-ui-carousel'
import './Works.css';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
// Import ../../assets/recentprojects/
import Portfolio from '../../assets/recentprojects/react-portfolio.png';
import Lunch from '../../assets/recentprojects/lunchnow.png';
import Slickfit from '../../assets/recentprojects/slickfit.png';
import Smiles from '../../assets/recentprojects/smiles.png';
import Startup from '../../assets/recentprojects/startup.png';
import Rent from '../../assets/recentprojects/rentloop.png';

const useStyles = makeStyles((theme) => ({
  main: {
    maxWidth: '100vw',
    marginTop: '3em',
    marginBottom: "auto",
  },
}));

export const Works = () => {
  const classes = useStyles();
  const [projects, setProjects] = useState([
    {
      id: 1,
      title: 'Smiles',
      description: `Smiles has developed a points program for valued customers to make sure that fees can be minimized or gone!
      Points can easily be earned every time you remit, when you first register, participate in campaigns and more!`,
      alter: 'React Portfolio',
      image: `${Smiles}`,
    },
    {
      id: 2,
      title: 'Lunch Now',
      description: `LunchNow shows you offers for delicious lunches in your city at a glance - currently in Hamburg, Frankfurt, Düsseldorf, Cologne, Stuttgart, Munich and Berlin. Discover new restaurants and receive individual offers every day. Use the app to meet friends, colleagues and business partners for lunch. Since June you can also pre-order and pay for your lunch at participating partner restaurants directly via the app.`,
      alter: 'Lunch Now',
      image: `${Lunch}`,
    },
    {
      id: 3,
      title: 'Slickfit',
      description: `Slickfitness App is a social platform that connect fitfam nation all around the world embarking on a fitness journey. Realtime find workout partner nearby. Find lots of workout excercises.`,
      alter: 'Slickfit',
      image: `${Slickfit}`,
    },
    {
      id: 4,
      title: 'Shoe Rocket',
      description: `It's an e-commerce platform through this platform you can sell your used shoes. It has frontend and admin panel.`,
      alter: 'Shoe Rocket',
      image: `${Startup}`,
    },
    {
      id: 5,
      title: 'Rent Loop',
      description: `Making renting
      smart,
      faster,
      easier.
      The first property rental lifecycle management software integrating everything in one place.`,
      alter: 'Rent Loop',
      image: `${Rent}`,
    },
  ]);

  function Project(props) {
    let project = props.item
    return (
      // <Paper>
      <div className="project" key={project.id}>
        <div className="__img_wrapper">
          <img src={project.image} alt={project.alter} />
        </div>
        <div className="__content_wrapper">
          <h3 className="title">
            <TextDecrypt text={project.id + '. ' + project.title} />
          </h3>
          <p className="description">
            {project.description}
          </p>
        </div>
      </div>
      // </Paper>
    )
  }

  return (
    <div id="works" className="parent_review">
      <Carousel
        autoPlay
        interval={4000}
        animation="slide"
        duration={1000}
        navButtonsAlwaysVisible={true}
      >
        {
          projects.map((item, i) => <Project key={i} item={item} />)
        }
      </Carousel>
    </div>
  );
};
